module.exports = __webpack_public_path__ + "static/media/NotoSans-Regular-Italic.5f4b8505.woff";